/**
 * --------------------------------------------------------------------------
 * Shopify Cart Debug Panel (Hidden by Default)
 * --------------------------------------------------------------------------
 * Shows a simple list of cart items (title, quantity input, remove button)
 * from the eager cart buffer. Includes a 'Show Details' toggle for full JSON
 * debug info. Panel is slightly wider for readability.
 * 
 * To show: Run "showCartDebug()" in browser console
 * To hide: Run "hideCartDebug()" in browser console
 */
(function() {
  if (window.__ShopifyCartDebugLoaded) return;
  window.__ShopifyCartDebugLoaded = true;

  // Panel reference
  let panel = null;
  let open = false;
  let showDetails = false;
  let realCart = null;
  let eagerCart = null;
  let lastError = null;
  let syncing = false;
  let pending = [];

  // Create panel function
  function createPanel() {
    if (panel) return; // Already exists
    
    panel = document.createElement('div');
    panel.style.position = 'fixed';
    panel.style.top = '1rem';
    panel.style.left = '1rem';
    panel.style.zIndex = 99999;
    panel.style.background = 'rgba(30,30,30,0.98)';
    panel.style.color = '#fff';
    panel.style.fontFamily = 'monospace';
    panel.style.fontSize = '13px';
    panel.style.borderRadius = '8px';
    panel.style.boxShadow = '0 2px 8px rgba(0,0,0,0.2)';
    panel.style.maxWidth = '520px';
    panel.style.minWidth = '320px';
    panel.style.maxHeight = '90vh';
    panel.style.overflowY = 'auto';
    panel.style.padding = '0';
    panel.style.transition = 'opacity 0.2s';
    panel.style.opacity = '0.8';

    // Toggle button
    const toggleBtn = document.createElement('button');
    toggleBtn.textContent = '🛒 Cart Debug';
    toggleBtn.style.background = '#222';
    toggleBtn.style.color = '#fff';
    toggleBtn.style.border = 'none';
    toggleBtn.style.borderRadius = '8px 8px 0 0';
    toggleBtn.style.padding = '6px 16px';
    toggleBtn.style.cursor = 'pointer';
    toggleBtn.style.width = '100%';
    toggleBtn.style.fontWeight = 'bold';
    toggleBtn.style.fontSize = '14px';
    toggleBtn.style.letterSpacing = '0.5px';
    toggleBtn.style.outline = 'none';
    toggleBtn.style.display = 'block';
    toggleBtn.addEventListener('click', () => {
      open = !open;
      content.style.display = open ? 'block' : 'none';
      panel.style.opacity = open ? '1' : '0.8';
    });

    // Content
    const content = document.createElement('div');
    content.style.display = 'none';
    content.style.padding = '12px 16px 16px 16px';

    // Real state refresh button
    const refreshBtn = document.createElement('button');
    refreshBtn.textContent = 'Refresh Real State';
    refreshBtn.style.background = '#444';
    refreshBtn.style.color = '#fff';
    refreshBtn.style.border = 'none';
    refreshBtn.style.borderRadius = '4px';
    refreshBtn.style.padding = '4px 10px';
    refreshBtn.style.cursor = 'pointer';
    refreshBtn.style.marginBottom = '8px';
    refreshBtn.style.fontSize = '12px';
    refreshBtn.addEventListener('click', () => {
      fetchRealCart();
    });

    // Clear cart button
    const clearBtn = document.createElement('button');
    clearBtn.textContent = 'Clear Cart';
    clearBtn.style.background = '#c00';
    clearBtn.style.color = '#fff';
    clearBtn.style.border = 'none';
    clearBtn.style.borderRadius = '4px';
    clearBtn.style.padding = '4px 10px';
    clearBtn.style.cursor = 'pointer';
    clearBtn.style.marginBottom = '8px';
    clearBtn.style.marginLeft = '8px';
    clearBtn.style.fontSize = '12px';
    clearBtn.addEventListener('click', () => {
      if (window.Shopify && window.Shopify.cart && typeof window.Shopify.cart.clear === 'function') {
        window.Shopify.cart.clear();
      }
    });

    // Flush pending adds button
    const flushBtn = document.createElement('button');
    flushBtn.textContent = 'Flush Pending';
    flushBtn.style.background = '#f90';
    flushBtn.style.color = '#fff';
    flushBtn.style.border = 'none';
    flushBtn.style.borderRadius = '4px';
    flushBtn.style.padding = '4px 10px';
    flushBtn.style.cursor = 'pointer';
    flushBtn.style.marginBottom = '8px';
    flushBtn.style.marginLeft = '8px';
    flushBtn.style.fontSize = '12px';
    flushBtn.addEventListener('click', () => {
      if (window.Shopify && window.Shopify.cart && typeof window.Shopify.cart.flushPendingOperations === 'function') {
        window.Shopify.cart.flushPendingOperations();
      }
    });

    // Show Details toggle
    const detailsBtn = document.createElement('button');
    detailsBtn.textContent = 'Show Details';
    detailsBtn.style.background = '#333';
    detailsBtn.style.color = '#fff';
    detailsBtn.style.border = 'none';
    detailsBtn.style.borderRadius = '4px';
    detailsBtn.style.padding = '4px 10px';
    detailsBtn.style.cursor = 'pointer';
    detailsBtn.style.marginBottom = '8px';
    detailsBtn.style.marginLeft = '8px';
    detailsBtn.style.fontSize = '12px';
    detailsBtn.addEventListener('click', () => {
      showDetails = !showDetails;
      detailsBtn.textContent = showDetails ? 'Hide Details' : 'Show Details';
      detailsDiv.style.display = showDetails ? 'block' : 'none';
    });

    // Cart items list
    const itemsDiv = document.createElement('div');
    itemsDiv.style.marginBottom = '12px';

    // Details (hidden by default)
    const detailsDiv = document.createElement('div');
    detailsDiv.style.display = 'none';

    // Status fields for details
    const eagerStatePre = document.createElement('pre');
    eagerStatePre.style.background = '#222';
    eagerStatePre.style.padding = '6px';
    eagerStatePre.style.borderRadius = '4px';
    eagerStatePre.style.overflowX = 'auto';
    eagerStatePre.style.marginBottom = '8px';

    const realStatePre = document.createElement('pre');
    realStatePre.style.background = '#222';
    realStatePre.style.padding = '6px';
    realStatePre.style.borderRadius = '4px';
    realStatePre.style.overflowX = 'auto';
    realStatePre.style.marginBottom = '8px';

    const networkStateDiv = document.createElement('div');
    networkStateDiv.style.marginBottom = '8px';

    // Compose content
    content.appendChild(refreshBtn);
    content.appendChild(clearBtn);
    content.appendChild(flushBtn);
    content.appendChild(detailsBtn);
    content.appendChild(itemsDiv);
    detailsDiv.appendChild(document.createTextNode('Eager (Buffer) State:'));
    detailsDiv.appendChild(eagerStatePre);
    detailsDiv.appendChild(document.createTextNode('Real (Shopify) State:'));
    detailsDiv.appendChild(realStatePre);
    detailsDiv.appendChild(document.createTextNode('Network State:'));
    detailsDiv.appendChild(networkStateDiv);
    content.appendChild(detailsDiv);

    panel.appendChild(toggleBtn);
    panel.appendChild(content);
    document.body.appendChild(panel);

    // Store references for update functions
    panel._itemsDiv = itemsDiv;
    panel._eagerStatePre = eagerStatePre;
    panel._realStatePre = realStatePre;
    panel._networkStateDiv = networkStateDiv;

    // Initial load
    setTimeout(() => {
      fetchRealCart();
      updatePanel();
    }, 500);
  }

  // Update panel
  function updatePanel() {
    if (!panel) return;
    
    // Eager state
    eagerCart = window.Shopify && window.Shopify.cart && window.Shopify.cart._cart;
    // Render cart items
    renderItems(eagerCart && eagerCart.items ? eagerCart.items : []);
    // Details
    panel._eagerStatePre.textContent = JSON.stringify(eagerCart, null, 2);
    panel._realStatePre.textContent = realCart ? JSON.stringify(realCart, null, 2) : '(not loaded)';
    // Network state
    const online = navigator.onLine;
    syncing = window.Shopify && window.Shopify.cart && window.Shopify.cart._syncing;
    pending = window.Shopify && window.Shopify.cart && window.Shopify.cart._queue ? window.Shopify.cart._queue : [];
    
    // Get debouncing info
    const debounceTimers = window.Shopify && window.Shopify.cart && window.Shopify.cart._addDebounceTimers ? window.Shopify.cart._addDebounceTimers.size : 0;
    const debounceQuantities = window.Shopify && window.Shopify.cart && window.Shopify.cart._addDebounceQuantities ? window.Shopify.cart._addDebounceQuantities.size : 0;
    const changeDebounceTimers = window.Shopify && window.Shopify.cart && window.Shopify.cart._changeDebounceTimers ? window.Shopify.cart._changeDebounceTimers.size : 0;
    
    panel._networkStateDiv.innerHTML =
      `<div>Online: <b style="color:${online ? '#0f0' : '#f33'}">${online ? 'Yes' : 'No'}</b></div>` +
      `<div>Syncing: <b style="color:${syncing ? '#ff0' : '#aaa'}">${syncing ? 'Yes' : 'No'}</b></div>` +
      `<div>Pending Actions: <b>${pending.length}</b></div>` +
      `<div>Debounced Adds: <b style="color:${debounceTimers > 0 ? '#ff0' : '#aaa'}">${debounceTimers}</b></div>` +
      `<div>Accumulated Quantities: <b style="color:${debounceQuantities > 0 ? '#ff0' : '#aaa'}">${debounceQuantities}</b></div>` +
      `<div>Debounced Changes: <b style="color:${changeDebounceTimers > 0 ? '#ff0' : '#aaa'}">${changeDebounceTimers}</b></div>` +
      (lastError ? `<div style="color:#f33">Last Error: ${lastError}</div>` : '');
  }

  // Render cart items list
  function renderItems(items) {
    if (!panel || !panel._itemsDiv) return;
    
    const itemsDiv = panel._itemsDiv;
    itemsDiv.innerHTML = '';
    if (!items.length) {
      itemsDiv.textContent = '(Cart is empty)';
      return;
    }
    items.forEach(item => {
      const row = document.createElement('div');
      row.style.display = 'flex';
      row.style.alignItems = 'center';
      row.style.gap = '8px';
      row.style.marginBottom = '6px';
      // Title
      const title = document.createElement('span');
      title.textContent = item.title || item.handle || item.id || 'Item';
      title.style.flex = '1 1 auto';
      title.style.overflow = 'hidden';
      title.style.textOverflow = 'ellipsis';
      title.style.whiteSpace = 'nowrap';
      // Quantity input
      const qty = document.createElement('input');
      qty.type = 'number';
      qty.min = '0';
      qty.value = item.quantity;
      qty.style.width = '48px';
      qty.style.background = '#111';
      qty.style.color = '#fff';
      qty.style.border = '1px solid #444';
      qty.style.borderRadius = '4px';
      qty.style.padding = '2px 4px';
      qty.addEventListener('change', () => {
        const newQty = parseInt(qty.value, 10);
        if (isNaN(newQty) || newQty < 0) return;
        if (newQty === 0) {
          window.Shopify.cart.remove(item.key || item.id);
        } else {
          window.Shopify.cart.change({ id: item.key || item.id, quantity: newQty });
        }
      });
      // Remove button
      const removeBtn = document.createElement('button');
      removeBtn.textContent = '✕';
      removeBtn.title = 'Remove';
      removeBtn.style.background = '#c00';
      removeBtn.style.color = '#fff';
      removeBtn.style.border = 'none';
      removeBtn.style.borderRadius = '4px';
      removeBtn.style.padding = '2px 8px';
      removeBtn.style.cursor = 'pointer';
      removeBtn.addEventListener('click', () => {
        window.Shopify.cart.remove(item.key || item.id);
      });
      row.appendChild(title);
      row.appendChild(qty);
      row.appendChild(removeBtn);
      itemsDiv.appendChild(row);
    });
  }

  // Fetch real cart
  function fetchRealCart() {
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        realCart = cart;
        updatePanel();
      })
      .catch(err => {
        realCart = null;
        lastError = err.message || String(err);
        updatePanel();
      });
  }

  // Listen for cart events
  window.addEventListener('cart:updated', (e) => {
    eagerCart = e.detail && e.detail.cart;
    updatePanel();
  });
  window.addEventListener('cart:error', (e) => {
    lastError = e.detail && e.detail.error ? JSON.stringify(e.detail.error) : 'Unknown error';
    updatePanel();
  });
  window.addEventListener('online', updatePanel);
  window.addEventListener('offline', updatePanel);

  // Console commands
  window.showCartDebug = function() {
    createPanel();
  };

  window.hideCartDebug = function() {
    if (panel) {
      panel.remove();
      panel = null;
      open = false;
      showDetails = false;
    }
  };

  // Initialize cart debug
  function initCartDebug() {
    // Cart debug loaded. Run "showCartDebug()" in console to show panel, "hideCartDebug()" to hide it.
  }
})(); 